import { HTMLRenderer } from '../../renderers/HTMLRenderer';
import { registerRenderer } from '../../registry/renderers';
export var htmlPlugin = {
    name: 'lightdraw-html',
    version: '1.2.1',
    install: function (_LD) {
        registerRenderer('html', function () { return new HTMLRenderer(); });
    },
};
export { HTMLRenderer };
export default htmlPlugin;
